<mat-card class="mb-2 h-100" *ngIf="data">
  <mat-card-content>
    <div class="card-header mb-1">
      <h3 class="info-title">{{data.title}}</h3>
      <a [href]="data.linkUrl" [target]="data.linkTarget" class="more-link">{{data.linkName}}</a>
    </div>
    <app-preloader *ngIf="!messages" [miniPreloader]="true"></app-preloader>
    <app-messages *ngIf="messages" [messages]="messages" />
  </mat-card-content>
</mat-card>